/**
 * PALETTE CATEGORIE — STANDARD per questo tool e per i PROSSIMI tool.
 *
 * Regola (decisione utente 2026-06-10): ogni TIPO di "pezzo" della conoscenza
 * ha la SUA tinta, identica ovunque appaia (mappe, chip, legende, viste
 * future). Tinte ≠ toni: i toni della stessa tinta si leggono come STATI
 * (evidenziato sì/no), le tinte diverse come CATEGORIE.
 *
 * Il blu ardesia del marchio (#2b4c6b) NON è una categoria: è riservato a
 * focus/selezione/autore-centrale.
 *
 * ⚠ Su questo tool il marchio è FREDDO (grigi e blu), quindi le categorie
 * stanno tutte nella metà calda: se una categoria fosse blu si leggerebbe come
 * «il colore del tool» invece che come categoria. È il vincolo speculare a
 * quello dello Spagnolo, dove le categorie dovevano scappare dall'arancio. Quando nasce una nuova categoria di
 * pezzi, le si assegna QUI una tinta nuova (e nei token CSS).
 *
 * ⚠ Tenere in sync con le var CSS `--cat-*` in src/styles/tokens-brand.css
 * (i chip e gli stili DOM usano le var; gli SVG generati in TS usano questi hex).
 */
export const CATEGORY_COLORS = {
  /** Autore / nodo centrale — blu ardesia del marchio */
  author: '#2b4c6b',
  /** Opera — ocra */
  work: '#7a5410',
  /** Tema generico — terracotta */
  theme: '#8f3f24',
  /** Movimento — prugna */
  movement: '#6f3a6d',
  /** Genere / forma — oliva */
  genre: '#4e6222',
  /** Periodo — granata */
  period: '#8a3340',
} as const;

export type CategoryKind = keyof typeof CATEGORY_COLORS;
